import { Menu, MenuItem } from "@mui/material";
import { Pages } from "../../utils";
import { Link } from "react-router";
import { HashLink } from "react-router-hash-link";

const links = [
  {
    to: Pages.ABOUT_US_PAGE,
    label: "About Us",
  },
  {
    to: `${Pages.ABOUT_US_PAGE}#the-seal`,
    label: "The Guild Seal",
  },
  {
    to: Pages.COMING_SOON,
    label: "ColorWorks",
  },
];

export const AboutUsNavMenu = ({
  anchor,
  onClose,
}: {
  anchor: HTMLElement | null;
  onClose: () => void;
}) => {
  return (
    <Menu
      anchorEl={anchor}
      open={Boolean(anchor)}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          width: {
            xs: "100vw",
            sm: "auto",
          },
        },
      }}
      keepMounted
    >
      {links.map((link) => (
        <MenuItem
          onClick={onClose}
          key={link.label}
          component={HashLink}
          to={link.to}
        >
          {link.label}
        </MenuItem>
      ))}
    </Menu>
  );
};
